import Vue from 'vue'
import VueRouter from 'vue-router'
import report_obj from '../views/report_obj.vue'
import importXLS from '../views/importXLS.vue'
import quarterly_report from '../views/quarterly_report.vue'
import selfEmployed from '../views/selfEmployed'
import report_tech from '../views/report_tech'
import moveMoney from '../views/moveMoney'
import payInvoice from '../views/payInvoice'
import planTech from "../views/planTech";

Vue.use(VueRouter)

const routes = [
  {
    path: '/salary2/',
    name: 'report_obj',
    component: report_obj
  },
  {
    path: '/salary2/import',
    name: 'importXLS',
    component: importXLS
  },
  {
    path: '/salary2/about',
    name: 'quarterlyReport',
    component: quarterly_report
  },
  {
    path: '/salary2/selfEmployed',
    name: 'quarterlyReport',
    component: selfEmployed
  },
  {
    path: '/salary2/report_tech',
    name: 'reportTech',
    component: report_tech
  },
  {
    path: '/salary2/moveMoney',
    name: 'moveMoney',
    component: moveMoney
  },
  {
    path: '/salary2/payInvoice',
    name: 'payInvoice',
    component: payInvoice
  },
  {
    path: '/salary2/planTech',
    name: 'payInvoice',
    component: planTech
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
